import { render, staticRenderFns } from "./dialogInPut.vue?vue&type=template&id=1b6964b1&scoped=true&"
import script from "./dialogInPut.vue?vue&type=script&lang=js&"
export * from "./dialogInPut.vue?vue&type=script&lang=js&"
import style0 from "./dialogInPut.vue?vue&type=style&index=0&id=1b6964b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6964b1",
  null
  
)

export default component.exports